<div class="switch-container">
  <label class="label-title mx-2">{{ label }}</label>
  <div class="shift-container mx-2">
    <modus-switch
     checked="{{value?true:false}}"
     (switchClick)="switchClick($event)" 
     label="{{value?'On':'Off'}}" size="small"></modus-switch>
  </div>
</div>
